import { http } from './shared';

/**
 * Implementation
 */
export const GenderService = {
  get: () => http.get('/genders'),
};
